import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Box, Typography } from "@mui/material";

const formatShortNumber = (value) => {
  if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1) + "B";
  if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
  if (value >= 1_000) return (value / 1_000).toFixed(1) + "K";
  return value;
};

const CustomerChart = ({ title, data }) => {
  const chartData = data.map((item) => ({
    ...item,
    total: parseFloat(item.total),
  }));

  const renderChart = (data) => (
    <ResponsiveContainer width="90%" height={260}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="fullName" />
        <YAxis tickFormatter={formatShortNumber} />
        <Tooltip
          formatter={(value) => [
            value.toLocaleString(),
            "Total Price",
          ]}
        />
        <Legend />
        <Bar dataKey="total" name="Total Price" fill="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );

  return (
    <Box>
      <Typography variant="h6">{title}</Typography>
      {renderChart(chartData)}
    </Box>
  );
};

export default CustomerChart;
